// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion_root__ae7_R"};